import { render, staticRenderFns } from "./fracionamentoKitEmbalagemItem.vue?vue&type=template&id=2316606c"
import script from "./fracionamentoKitEmbalagemItem.ts?vue&type=script&lang=js&external"
export * from "./fracionamentoKitEmbalagemItem.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/1/s/TafStore.PharmUP.Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2316606c')) {
      api.createRecord('2316606c', component.options)
    } else {
      api.reload('2316606c', component.options)
    }
    module.hot.accept("./fracionamentoKitEmbalagemItem.vue?vue&type=template&id=2316606c", function () {
      api.rerender('2316606c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/crud/produtolote/fracionamentoKitEmbalagemItem.vue"
export default component.exports